import auth from './auth';
import user from './user';
import workspace from './workspace';
import customer from './customer';
import device from './device';
import deviceHistory from './deviceHistory';
import eventGroup from './eventGroup';
import emergencyContact from './emergencyContact';
import emergencyContactList from './emergencyContactList';
import monitoring from './monitoring';
import model from './model';
import brands from './brands';
import resolution from './resolution';
import event from './event';
import invitations from './invitations';
import places from './place';
import users from './users';
import upload from './upload';
import conversations from './conversations';
import serviceOrders from './serviceOrders';
import translations from './translations';

export default {
  auth,
  user,
  workspace,
  customer,
  device,
  deviceHistory,
  brands,
  event,
  eventGroup,
  emergencyContact,
  emergencyContactList,
  monitoring,
  model,
  resolution,
  invitations,
  places,
  users,
  upload,
  conversations,
  serviceOrders,
  translations,
};
